import { InjectionToken } from '@angular/core';
import type { ExcelEngine } from '../infrastructure/excel-engine.port';
import type { CorporateTheme } from '../theme/corporate-theme';

export const EXCEL_ENGINE = new InjectionToken<ExcelEngine>('EXCEL_ENGINE');

export const REPORT_THEME = new InjectionToken<CorporateTheme>(
  'REPORT_THEME',
);
